import { el } from './dom.js';

/**
 * The only controls the validator has.
 *
 * Two checkboxes: show the diagnostic overlay, and optionally show the detailed
 * markup (landmarks, pose angles, measurements). There is deliberately **no**
 * zoom, rotation, centring, reset or cropping — this is a validator, not an
 * editor.
 */

export interface OverlayToggleState {
  showOverlay: boolean;
  detailMode: boolean;
  hasImage: boolean;
}

export interface OverlayToggleHandlers {
  onToggleOverlay(value: boolean): void;
  onToggleDetail(value: boolean): void;
}

export interface OverlayToggles {
  element: HTMLElement;
  update(state: OverlayToggleState): void;
}

export const createOverlayToggles = (handlers: OverlayToggleHandlers): OverlayToggles => {
  const overlayToggle = el('input', {
    type: 'checkbox',
    checked: true,
    id: 'pv-toggle-overlay',
    'data-action': 'toggle-overlay',
  });
  const detailToggle = el('input', {
    type: 'checkbox',
    id: 'pv-toggle-detail',
    'data-action': 'toggle-detail',
  });

  overlayToggle.addEventListener('change', () => handlers.onToggleOverlay(overlayToggle.checked));
  detailToggle.addEventListener('change', () => handlers.onToggleDetail(detailToggle.checked));

  const element = el('div', { class: 'pv-stage-toolbar pv-stage-toolbar--minimal' }, [
    el('label', { class: 'pv-toggle', for: 'pv-toggle-overlay' }, [
      overlayToggle,
      el('span', { text: 'Показать разметку' }),
    ]),
    el('label', { class: 'pv-toggle', for: 'pv-toggle-detail' }, [
      detailToggle,
      el('span', { text: 'Подробная разметка' }),
    ]),
    el('span', {
      class: 'pv-small pv-muted',
      text: 'Фотография не изменяется: разметка только показывает, что именно измерил валидатор.',
    }),
  ]);

  return {
    element,
    update: (state) => {
      overlayToggle.checked = state.showOverlay;
      detailToggle.checked = state.detailMode;
      overlayToggle.disabled = !state.hasImage;
      detailToggle.disabled = !state.hasImage;
    },
  };
};
